import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';
import { confirmUnsubscribe, getVerifiedSubscriber } from '../api/fetchApi';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { settingAr, settingEn } from '../helpers/translations/cssClassHelper';

class Unsub extends Component {
  constructor(props) {
    super(props);
    this.defaultLang = window.navigator.language ? window.navigator.language : 'en';
    this.state = {
      isError: false,
      isLoading: false,
      isManual: false,
      isValid: false,
      verifiedSubscriber: {},
      locale: this.defaultLang,
      unsubscribeConfirmed: {},
      id: null,
      isCancel: false,
    };
  }

  componentDidMount() {
    const { id } = this.props.match.params;
    this.setState({ id });
    /* Call API to check the id
    API will returns:
    a. success:false if the id is not valid
    b. success: true
    c. success: true, pending
    If the response is success:false, display an error message box saying that the id is not valid/ not found
    If the response is success:true, then display a message box saying that the unsubsribe service is successfull
    If the response is success:pending, display a simple confirmation page with a unsub button, once the user clicks
    the unsub button call the unsub api */
    /* i18next.changeLanguage(this.state.locale); */
    this.props.getVerifiedSubscriber(id, this.props.option);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const iLang = this.props.i18n.language;
    if (iLang) {
      if (iLang === 'ar') {
        settingAr(this.props.i18n);
      } else {
        settingEn(this.props.i18n);
      }
    }

    if (this.state.isError) {
      document.querySelector('html').classList.add('ltr');
    }

    if (nextProps.getVerified && nextProps.getVerified != this.state.verifiedSubscriber && _.isEmpty(nextProps.unsubscribeConfirmed)) {
      const verifiedInfo = nextProps.getVerified;
      this.setState({ locale: verifiedInfo.locale, verifiedSubscriber: nextProps.verifiedSubscriber });

      if (verifiedInfo.success && verifiedInfo.operator_cc_unsub_page) {
        window.location.replace(verifiedInfo.operator_cc_unsub_page);
      } else if (verifiedInfo.success && verifiedInfo.pending) {
        this.setState({ isManual: true });
      } else if (verifiedInfo.success) {
        this.setState({ isValid: true, isError: false });
      } else {
        this.setState({ isError: true });
      }
    }
    if (nextProps.unsubscribeConfirmed && nextProps.unsubscribeConfirmed !== this.state.unsubscribeConfirmed) {
      const verifiedInfo = nextProps.unsubscribeConfirmed;

      this.setState({ locale: verifiedInfo.locale });

      if (verifiedInfo.success) {
        this.setState({
          isValid: true, isLoading: false, isManual: false, unsubscribeConfirmed: nextProps.unsubscribeConfirmed,
        });
      }
    }
  }

  UnsubCancelInfoBox(width) {
    return [
      <React.Fragment key="rf3">
        <div className={width < 600 ? 'borderRadius-small alert-unsubsuccess' : 'borderRadius alert-unsubsuccess'} role="alert" key="1">
          <div className="row justify-content-center text-center"><h4 className="alert-header">{this.props.t('title.cancel')}</h4></div>
          <div className="row justify-content-center"><p className="text-center">{ this.props.t('message.cancel') }</p></div>
        </div>
        <Footer />
      </React.Fragment>,
    ];
  }

  UnsubConfirmBox(width) {
    return [
      <React.Fragment key="rf1">
        <div className={width < 600 ? 'borderRadius-small alert-unsubconfirm' : 'borderRadius alert-unsubconfirm'} role="alert" key="1">
          <div className="row justify-content-center text-center"><h4 className="alert-header">{this.props.t('message.confirm')}</h4></div>
          <div className="flex-parent jc-center">
            <button
              type="button"
              data-test="submit-button"
              id="btnCancel"
              className="btn btn-secondary margin-right"
              onClick={this.cancelSubmit.bind(this)}
              disabled={this.state.isLoading}
            >
              {this.props.t('button.cancel')}
            </button>
            <button
              type="button"
              data-test="submit-button"
              id="btnLogin"
              className="btn btn-primary"
              onClick={this.handleSubmit.bind(this)}
              disabled={this.state.isLoading}
            >
              {this.state.isLoading ? this.props.t('button.processing') : this.props.t('button.unsub')}
              {this.state.isLoading
                && <i className="fa fa-refresh fa-spin" style={{ marginLeft: '25px' }} />}
            </button>
          </div>
        </div>
        <Footer />
      </React.Fragment>,
    ];
  }

  UnsubFailedInfoBox(width) {
    return [
      <div className={width < 600 ? 'borderRadius-small alert-danger' : 'borderRadius alert-danger'} role="alert" key="1">
        <div className="row justify-content-center text-center"><h4 className="alert-header">{this.props.t('title.failed') }</h4></div>
        <div className="row justify-content-center">
          {' '}
          <p className="text-center">{ this.props.t('message.failed') }</p>
        </div>
      </div>,
      <Footer />,
    ];
  }

  UnsubSuccessInfoBox(width) {
    return [
      <div className={width < 600 ? 'borderRadius-small alert-unsubsuccess' : 'borderRadius alert-unsubsuccess'} role="alert" key="1">
        <div className="row justify-content-center text-center">
          <h4 className="alert-header">{this.props.t('title.success') }</h4>
        </div>
        <div className="col-xs-3 text-center justify-content-center">
          <div className="p-break-word">
            <p className="text-center">{ this.props.t('message.success') }</p>
          </div>
        </div>
      </div>,
      <Footer />,
    ];
  }

  cancelSubmit(e) {
    e.preventDefault();
    this.setState({
      isValid: false, isLoading: false, isCancel: true, isManual: false,
    });
  }

  changeLanguage(i18n) {
    if (i18n.language !== this.state.locale) {
      i18n.changeLanguage(this.state.locale);
    } else if (i18n.language === 'en') {
      i18n.changeLanguage('ar');
    } else {
      i18n.changeLanguage(this.defaultLang);
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({ isLoading: true });
    this.props.confirmUnsubscribe(this.state.id, this.props.option);
  }

  render() {
    const { i18n, t } = this.props;

    return (
      <React.Fragment key="rf2">
        <Header unsub {...this.props} locale={this.state.locale} />
        <div id="wrap">
          <div id="main" className="container-fluid">
            <br />
            {this.state.isError ? this.UnsubFailedInfoBox(this.props.width) : null}
            {this.state.isManual && !this.state.isCancel ? this.UnsubConfirmBox(this.props.width) : null}
            {this.state.isValid ? this.UnsubSuccessInfoBox(this.props.width) : null}
            {this.state.isCancel ? this.UnsubCancelInfoBox(this.props.width) : null}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  getVerified: state.unsubs.verifiedSubscriber,
  unsubscribeConfirmed: state.unsubs.unsubscribeConfirmed,
});

const mapDispatchToProps = (dispatch) => ({
  getVerifiedSubscriber: (id, option) => dispatch(getVerifiedSubscriber(id, option)),
  confirmUnsubscribe: (id, option) => dispatch(confirmUnsubscribe(id, option)),
});

export { Unsub };
export default withTranslation('lang')(withRouter(connect(mapStateToProps, mapDispatchToProps)(Unsub)));
